import Pill from 'v2/components/Pill';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const CompactPill: FunctionComponent<Props> = ({
    children,
    className = '',
    testId = TEST_ID,
    title
}) => (
    <Pill className={`${styles.compactPill} ${className}`} testId={testId} title={title}>
        {children}
    </Pill>
);

export default CompactPill;
